import type { ThemeName } from "../hooks/useTheme";

export function ThemeToggle({
  theme,
  onToggle,
}: {
  theme: ThemeName;
  onToggle: () => void;
}) {
  const next = theme === "dark" ? "LIGHT" : "DARK";
  return (
    <button
      className="btn ghost"
      onClick={onToggle}
      aria-label={`Switch to ${next.toLowerCase()} theme`}
      title={`Switch to ${next.toLowerCase()} theme`}
      data-testid="theme-toggle"
    >
      <span aria-hidden style={{ fontSize: 16 }}>
        {theme === "dark" ? "☾" : "☼"}
      </span>
      <span style={{ fontSize: 12, fontWeight: 600, letterSpacing: "0.12em" }}>
        {theme === "dark" ? "DARK" : "LIGHT"}
      </span>
    </button>
  );
}
